<style lang="less">
@import url("~@/assets/css/public.css");
.noData {
    color: #888;
    padding: 10px 0;
    text-align: center;
}
.pageTitle {
    color: #6482AF;
    font-size: 25px;
    font-weight: 100;
    margin-top: 10px;
}
.tableWrap {
    padding: 15px;
    background: #FFF;
    box-shadow: 0 0 5px #888;
    min-height: 60vh;
}

.searchBtn {
    margin-left: 15px !important;
    width: 100px;
}
.searchBoxWrap {
    margin: 10px 0 18px;
}
.PageWrap {
    text-align: right;
    padding: 20px 0;
}
.ModalHeader {
    div {
        color: #6482AF;
        text-align: center;
        font-size: 18px;
    }
}
.ModalBtn {
    button {
        min-width: 80px;
        margin: 0 5px !important;
    }
}
.blueBtn {
    background: #6482AF !important;
    border: #6482AF solid 1px !important;
    transition: 0.3s !important;
    &:hover {
        opacity: 0.8;
    }
}
.priColor {
    color: #15123E;
}
.upload {
    display: block;
    width: 100%;
    height: 100%;
    cursor: pointer;
    position: relative;
    &:hover {
        box-shadow: 0 0 5px #333;
    }
    &::before {
        display: block;
        content: "";
        width: 50px;
        height: 5px;
        background: #000;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    &::after {
        display: block;
        content: "";
        height: 50px;
        width: 5px;
        background: #000;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>

<template>
    <div class="">
        <router-view></router-view>
    </div>
</template>

<script>

    export default {
        name: "app",
        created () {
            this.$store.dispatch("initUserInfo")
            localStorage.setItem("local", "zh-TW")

        }
    }
</script>

